import { ChangeDetectorRef, Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { safelyDetectChanges, unsubscribeAll } from 'src/app/common/app.helpers';

import AppValues from 'src/app/common/app.values';
import { FileManagerService } from '../../files/file-manager.service';
import { NotificationType } from '../component-type.enum';
import { NotificationDataPayload, NotificationMessagePayload } from '../interfaces';
import { NotificationContext } from '../notification.context';
@Component({
  selector: 'app-informational-notification',
  templateUrl: './informational-notification.component.html',
  styleUrls: ['./informational-notification.component.scss'],
})
export class InformationalNotificationComponent extends NotificationContext implements OnDestroy {
  public readonly DATE_TIME_FORMAT_SHORT: string = AppValues.DATE_TIME_FORMAT_SHORT;
  public readonly notificationType: NotificationType = NotificationType.Informational;

  public downloadLink = '';
  public isFileDownloading = false;

  private subscriptions$: Subscription[] = [];

  private fileService = inject(FileManagerService);
  private changeDetector = inject(ChangeDetectorRef);

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public handleAreaMessageElementClick(data: NotificationDataPayload): void {
    if (data.routerUrl) {
      this.handleRoute(data);
    }

    if (data.fileId) {
      this.downloadFile(data.fileId);
    }
  }

  public handleMessageElementClick(chunk: NotificationMessagePayload): void {
    if (chunk.href) {
      this.navigate(chunk);
    }

    if (chunk.fileId) {
      this.downloadFile(chunk.fileId);
    }
  }

  public onFileDownloadError(): void {
    this.isFileDownloading = false;
  }

  public onFileDownloadChanged(isDownloading: boolean): void {
    this.isFileDownloading = isDownloading;
  }

  private downloadFile(fileId: string): void {
    this.subscriptions$.push(
      this.fileService.showAndDownloadFiles(fileId).subscribe((url: string) => {
        this.downloadLink = url;
        safelyDetectChanges(this.changeDetector);
      }),
    );
  }
}
